import { stringToType } from '../models/Message'

export const splitMessageType = (messageType: string) => {
  const messageTypeSplit = messageType.split('.')
  const lineOfBusiness = messageTypeSplit?.length > 1 ? messageTypeSplit[0] : 'tci'
  const type = messageTypeSplit?.length > 1 ? messageTypeSplit[1] : messageTypeSplit[0]
  return { lineOfBusiness, type: stringToType(type) }
}
